import { useContext } from "react";
import { ThemeContext } from "../theme/ThemeContext";

export function useV2Theme() {
  return useContext(ThemeContext);
}
